module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-282.3267c89.woff2";